import { render, staticRenderFns } from "./SkipMessage.vue?vue&type=template&id=38dca4bc&"
import script from "./SkipMessage.vue?vue&type=script&lang=ts&"
export * from "./SkipMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports